import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategoryStrip() {
  return (
    <section className="container-site -mt-10 relative z-20">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.id}`}
            className="group flex flex-col items-center gap-2 rounded-lg bg-background-50 px-3 py-5 text-center transition-colors hover:bg-primary-50"
            title={`${cat.name}漫画分类`}
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-lg`}></i>
            </span>
            <span className="text-sm font-semibold text-foreground-900">{cat.name}</span>
            <span className="text-xs text-foreground-500">{cat.count} 部</span>
          </Link>
        ))}
      </div>
    </section>
  );
}